<template>
  <div class="row">
    <div class="col col-12">
      <input class="form-control" :value="valueMutable" readonly>
    </div>
    <div class="col-md-2 mt-1">
      <div class="btn-group">
        <button
          class="btn btn-outline-secondary"
          v-b-tooltip="'Abrir editor visual'"
          @click="openEditor"
          v-if="hasPermisionSave"
        >
          <span class="material-icons">edit</span>
        </button>
      </div>
    </div>
    <b-modal
      ref="modaleditar"
      title="Editor de plantilla de firma"
      size="xl"
      hide-footer
    >
      <div class="row">
        <div class="col-md-7">
          <StampTemplateEditor v-model="valueMutable" />
        </div>
        <div class="col-md-5">
          <div class="sticky-top" style="top: 10px;">
            <StampPreviewCanvas
              :template="valueMutable"
              :userData="dummyUserData"
              :companyData="dummyCompanyData"
              @update-position="onPositionUpdate"
              @update-size="onSizeUpdate"
            />
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import StampTemplateEditor from '@/febos/global/usuario/components/sign/shared/StampTemplateEditor';
import StampPreviewCanvas from '@/febos/global/usuario/components/sign/shared/StampPreviewCanvas';
import InputConfigMixin from '@/febos/global/empresas/componentes/configs/inputs/InputConfigMixin';

export default {
  name: 'ConfigInputTextSignatureTemplate',
  mixins: [InputConfigMixin],
  components: {
    StampTemplateEditor,
    StampPreviewCanvas
  },
  data: () => ({
    valueMutable: '',
    dummyUserData: {
      nombre: 'Juan Pérez González',
      cargo: 'Gerente de Operaciones',
      iut: '12345678-9',
      correo: 'juan.perez@empresa.cl'
    },
    dummyCompanyData: {
      razonSocial: 'Empresa Ejemplo SpA'
    }
  }),
  mounted() {
    this.valueMutable = this.value;
  },
  watch: {
    valueMutable(val) {
      this.$emit('input', val);
    }
  },
  methods: {
    openEditor() {
      this.$refs.modaleditar.show();
    },
    onPositionUpdate(lineIndex, newX, newY) {
      const lines = (this.valueMutable || '').split('\n').filter(l => l.trim());
      if (lineIndex < 0 || lineIndex >= lines.length) return;
      const split = lines[lineIndex].split('||||');
      if (split.length < 2) return;
      let config = split[0].trim();
      const text = split[1];
      config = config.replace(/X=-?\d+/, `X=${newX}`).replace(/Y=-?\d+/, `Y=${newY}`);
      lines[lineIndex] = `${config} |||| ${text.trim()}`;
      this.valueMutable = lines.join('\n');
    },
    onSizeUpdate(lineIndex, newAx, newAy) {
      const lines = (this.valueMutable || '').split('\n').filter(l => l.trim());
      if (lineIndex < 0 || lineIndex >= lines.length) return;
      const split = lines[lineIndex].split('||||');
      if (split.length < 2) return;
      let config = split[0].trim();
      const text = split[1];
      config = config.replace(/AX=-?\d+/, `AX=${newAx}`).replace(/AY=-?\d+/, `AY=${newAy}`);
      lines[lineIndex] = `${config} |||| ${text.trim()}`;
      this.valueMutable = lines.join('\n');
    }
  },
  props: {
    value: {
      type: String,
      required: false,
    },
    param: {
      type: String,
      required: false,
    },
    level: {
      type: String,
      required: false,
    }
  }
};
</script>
